import React from 'react'

function InvoiceListHeaderStyle({signed_in}) {
  let tb_buttons_display = null
  if (signed_in !== 'admin') tb_buttons_display = { invoice_fc: (signed_in.user_access.invoice_fc) ? 'block' : 'none' }
  else tb_buttons_display = { invoice_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* DON'T DELETE FOR REFERENCE
        #refresh-list:hover .tooltip-text { left: 0%; }
        #refresh-list:hover .tooltip-text::after { left: 30%; }
        #settings:hover .tooltip-text { left: 20.8%; }
        #add-new-invoice:hover .tooltip-text { left: 28%; }
        #batch-delete:hover .tooltip-text { left: 50%; }
        #batch-delete:hover .tooltip-text::after { left: 75%; }
        */

        /** Toolbar Button's **/
        #add-new-invoice, #batch-delete { display: ${tb_buttons_display.invoice_fc}; }

        #invoiceslist-toolbar {
          display: flex;
          padding: 5px 0;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(InvoiceListHeaderStyle)
